import React from 'react';
import PropTypes from 'prop-types';
import AdminSettings from './AdminSetting';

const SystemSettingsUtm = props => {
  const { settings, save } = props;
  const values = {
    utm_exp: settings.utm_exp,
    dtm_operations_url: settings.dtm_operations_url,
    utm_operations_url: settings.utm_operations_url,
  };

  return (
    <AdminSettings
      key="UTM"
      save={save}
      valuesInit={values}
      settingTitle="UTM"
    />
  );
};

SystemSettingsUtm.propTypes = {
  settings: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
};
export default SystemSettingsUtm;
